import React from 'react';
import { connect } from "react-redux";
import Loader from '../../../../Global/loader.js'
import { store } from 'react-notifications-component';
import BootstrapTable from 'react-bootstrap-table-next';
import { AiFillEdit, AiOutlineSearch } from 'react-icons/ai'
import { RiDeleteBin5Line } from 'react-icons/ri'
import Modal from 'react-modal';
import deleteItem from '../../../../API/Provider/DeleteProviderCountry.js'
import CreateItem from './CreateDrzava.js'
import UpdateItem from './UpdateDrzava.js'
import { withNamespaces } from 'react-i18next';
import GetCountries from './../../../../API/Provider/GetProviderCountries'
import { v4 as uuidv4 } from 'uuid';
import Pagination from "react-js-pagination";
import { Dropdown, Button, Row, Col, Form } from "react-bootstrap";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { BsArrowDownUp } from 'react-icons/bs'
import CreateButton from './../../../../Global/CreateButton'
import ButtonWithDropdown from '../../../../Global/ButtonWithDropdown'
import history from '../../../../history.js';

class Drzave extends React.Component {
    constructor(props) {
        super(props)
    
        this.state={
            loading: true,
            create: false,
            showDeleteModal: false,     
            uuidForDelete: "",  
            showOneItem: false,
            premesisList: [],
            countries: [],
            country: {},
            
            customStyles: {
                content : {
                    top                   : '50%',
                    left                  : '50%',
                    right                 : 'auto',
                    bottom                : 'auto',
                    transform             : 'translate(-50%, -50%)',
                    color: 'red'
                }
            },
            
            staticListSortBy: [
                {"name": "Name", "id": 0},
                {"name": "Alpha 2", "id": 1},
                {"name": "Alpha 3", "id": 2},
                {"name": "UN", "id": 3}
            ]
        }
    }

    componentDidMount = async () => {
        this.setState({loading: true})  

        //get countries
        let items = await GetCountries(this.props)  
        
        await this.props.mapState("MAP_PROVIDER_COUNTRY_LIST", items.data)

        await this.setState({
            loading: false
        })
    }

    toggleCreate = async () => {
        this.setState({
            create: !this.state.create
        })
    }

    backFromCreate(){
        this.setState({
            create: !this.state.create
        })
        this.componentDidMount()
    }

    backFromEdit(){
        this.setState({
            showOneItem: !this.state.showOneItem
        })
        this.componentDidMount()
    }

    showDeleteModal = (uuid, country_uuid) => {
        this.setState({
            showDeleteModal: !this.state.showDeleteModal,
            uuidForDelete: uuid,
            country_uuid: country_uuid
        });
    };

    confirmDelete = async () => {
        
        let deleted = await deleteItem(this.state.uuidForDelete)
        if(deleted.status === 200){
            await this.setState({
                showDeleteModal: false,
                uuidForDelete: ""
            })     
            await store.addNotification({
                title: this.props.t('Error!'),
                message: this.props.t('There was an error deleting your Client type, please try again'),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 15000,
                  onScreen: true
                }
            }) 
        }
        else{
            await this.setState({
                showDeleteModal: false,
                uuidForDelete: ""
            })

            await store.addNotification({
                title: this.props.t('Success!'),
                message: this.props.t('The client type was deleted'),
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            }) 

            this.componentDidMount()
        }
    }

    seeDetails = async (data) => {
        await this.props.mapState("MAP_CODEBOOK_ONE_CCOUNTRY", data)
        await this.setState({
            showOneItem: !this.state.showOneItem
        })
    }

    goBack(){
        history.goBack();
    }

    handlePageChange = async (pageNumber) => {

        await this.props.mapState("MAP_CODEBOOK_COUNTRY_LIST_ACTIVE_PAGE", pageNumber);

        await this.componentDidMount();
    }

    handleItemsPerPageChange = async (itemsPerPage) =>{
        await this.setState({ itemsPerPage: itemsPerPage });

        await this.componentDidMount();
    }

    onItemsPerPageChange = async (size) => {
        await this.props.mapState("MAP_CODEBOOK_COUNTRY_LIST_PAGE_SIZE", size);
        await this.props.mapState("MAP_CODEBOOK_COUNTRY_LIST_ACTIVE_PAGE", 1);
        await this.componentDidMount();
    };

    sortBy = async (data) => {
        this.props.mapState("CHANGE_SORTBY_CODEBOOK_COUNTRY_PARAMETERS", data)

        this.componentDidMount()
    }

    toggleSortDirection = async (data) => {
        this.setState({
            loading: true
        })
        
        await this.props.mapState("MAP_CODEBOOK_COUNTRY_SORT_DIRECTION", data === 0 ? 1 : 0)
        
        await this.componentDidMount();
    }

    toggleOnlyActive= async (data) => {
        await this.setState({
            loading: true
        })

        await this.props.mapState("MAP_CODEBOOK_COUNTRY_ACTIVE_ONLY", data)
        await this.componentDidMount();       
    }

    handleChange = async (e) => { 
        await this.props.mapState("CHANGE_SEARCH_CODEBOOK_COUNTRY_PARAMETERS", e.target)   
    }

   
    render(){
        const { loading, create, showOneItem } = this.state 
        const { t } = this.props

        const columns = [{
            dataField: 'uuid',
            text: t('Uuid'),
            headerStyle: {wordWrap: "break-word"},  
            hidden:true
        }, {
            dataField: 'country_name',
            text: t('Name'),
            headerStyle: {wordWrap: "break-word"},  
        }, {
            dataField: 'country_alpha2_code',
            text: t('Country'),
            headerStyle: {wordWrap: "break-word"}, 
        },{
            dataField: 'fiscalize',
            text: t('Fiscalize'),
            headerStyle: {wordWrap: "break-word"}, 
            formatter: (cellContent, row) => {          
                return (
                    <div key={row.uuid} className={`${row.fiscalize ? "color-green" : "color-red"}`}>
                        <strong>
                            { row.fiscalize ?  t("Yes") : t("No") }
                        </strong>
                    </div>
                );
                }
        },{
            dataField: 'sakriveno',
            isDummyField: true,
            text: '',
            style: {width: "11.8em"} ,
            formatter: (cellContent, row) => {          
            return (
                !row.deleted ?
                    <div key={uuidv4()}>
                        <Button
                            variant="success"
                            className="btnDetalji me-2"
                            onClick={() => this.seeDetails(row)}
                        >
                            <AiFillEdit /> {t("Details")}
                        </Button>

                        <Button
                            variant="danger"
                            className="btnIzbrisi"
                            onClick={() => this.showDeleteModal(row.uuid, row.country_uuid)}
                        >
                            <RiDeleteBin5Line /> {t("Delete")}
                        </Button>                       
                    </div>
                : <div key={uuidv4()}/>
            );
            }
        }]   

    return (
        loading ? 
            <Loader />
        :
        <>
            {showOneItem? 
                <UpdateItem goBack={() => this.backFromEdit()} />
            :
            create ? 
                <CreateItem goBack={() => this.backFromCreate()} />
            :  
                <div className="container mt-4">
                    <Row>        
                        <Col sm={8} md={8} xl={3} className="d-flex">
                            <Form.Control
                                id="searchFor"
                                type="text"
                                className="btn-succes-focus-visible h-100"
                                value={this.props.search.searchFor}
                                onChange={e => this.handleChange(e)}
                            />
                            <Button 
                                variant='success'
                                className="search-append-button h-100"
                                onClick={() => this.componentDidMount()}
                            >
                                <AiOutlineSearch size={20} />
                            </Button>
                        </Col>

                        <Col sm={0} xl={5} />  

                        <Col sm={6} xl={4}>
                            <CreateButton style={{padding:"0px"}} className="col-6 col-xl-4" toggleCreate={this.toggleCreate}/>
                        </Col>
                    </Row>
            
                    {this.props.countryList.length > 0 ?
                    <div className="mt-4">
                        <ToolkitProvider
                            keyField="uuid"
                            data={this.props.countryList}
                            columns={columns}
                            columnToggle
                            bodyStyle={{wordBreak: 'break-word'} }                         
                        >
                            {(props) => (
                            <div>
                                <Button
                                    variant="light" 
                                    className="sort-direction-button"
                                    data-toggle="button" 
                                    label="in_VAT"
                                    id="in_VAT"
                                    onClick={() => this.toggleSortDirection(this.props.sortDirection) }
                                >
                                    <BsArrowDownUp />
                                </Button>

                                <Dropdown 
                                    className="sortBy-button"
                                >
                                <Dropdown.Toggle
                                    variant="success"
                                    id="dropdown-basic"
                                >
                                    {t(this.props.sortBy.name)}
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    {this.state.staticListSortBy.map((data, index) =>{
                                        return  <Dropdown.Item
                                        key={index}
                                        onClick={() =>
                                            this.sortBy(data)
                                        }
                                    >
                                        {t(data.name)}
                                    </Dropdown.Item>
                                    })}
                                </Dropdown.Menu>
                                </Dropdown>  

                                <br/><br/>
                                <BootstrapTable {...props.baseProps} hover bodyClasses="table-body" />
                            </div>
                            )}
                        </ToolkitProvider>

                        <br />

                        <div className="container">
                            <div className="row justify-content-md-center m-0">
                                <div className="col-2">
                                    <ButtonWithDropdown 
                                        itemsPerPage={[10, 20, 30, 50]}
                                        active={this.props.pageSize}
                                        onItemsPerPageChange={this.onItemsPerPageChange}
                                        className="itemsPerPage"
                                        toggleId="dropdown-basic"
                                        styleToggle={{width:"auto"}}
                                    />
                                </div>
                                <div className="col-8 text-center">
                                    <Pagination
                                        //className="pagination"
                                        firstPageText="1"
                                        lastPageText={Math.ceil(
                                            this.props.total_number_of_records /
                                                this.props.pageSize
                                        ).toString()}
                                        hideDisabled
                                        activePage={this.props.activePage}
                                        itemsCountPerPage={this.props.pageSize}
                                        totalItemsCount={this.props.total_number_of_records}
                                        pageRangeDisplayed={5}
                                        onChange={this.handlePageChange.bind(this)}
                                        itemClass="page-item"
                                        linkClass="page-link"
                                    />
                                </div>
                                <div className="col-2">
                                    <ButtonWithDropdown 
                                        itemsPerPage={["All", "Active", "Inactive"]}
                                        active={this.props.activeOnly}
                                        onItemsPerPageChange={this.toggleOnlyActive}
                                        toggleId="dropdown-basic"
                                        className="itemsPerPage" 
                                        styleToggle={{
                                            float:"right",
                                            width: "auto"
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                        <div className="list-empty-container">
                            <h1>{t(this.props.message)}</h1>
                        </div>
                    }

                    <Modal
                        isOpen={this.state.showDeleteModal}                
                        onRequestClose={() => this.showDeleteModal("")}
                        style={this.state.customStyles}
                    >
        
                        <h3 className="modal-title">{t('Warning!')}</h3>
                    
                        <div className="mb-4">
                            <p>
                                {t('Deleting Country will also delete other data related to it.')}  
                            </p>
                        </div>

                        <Row>
                            <Col sm={6}>
                                <Button variant="primary" onClick={() => this.showDeleteModal("")}>{t('Close')}</Button>
                            </Col>
                            <Col sm={6}>
                                <Button variant="danger" onClick={() => this.confirmDelete()}> {t('Delete')}</Button>
                            </Col>                
                        </Row>
                
                    </Modal> 
                    
                </div>
            }   
                            
        </>
    )
}
}
const mapStateToProps = state => {
    return {
        message: state.adminClient.message,        
        credentials: state.user.credentials,
        countryList: state.codeBook.countryList,
        total_number_of_records: state.codeBook.Country.total_number,
        pageSize: state.codeBook.Country.pageSize,
        activePage: state.codeBook.Country.activePage,
        sortBy: state.codeBook.Country.sortBy,
        activeOnly: state.codeBook.Country.activeOnly,
        sortDirection: state.codeBook.Country.sortDirection,
        search: state.codeBook.Country.search
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
   
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(Drzave));